<template>
  <PageTemplate :loading="loading">
    <v-container v-if="!loading" class="pt-10 pb-12">
      <Title>Busca</Title>

      <v-row v-if="items.length" class="my-0">
        <v-col
          cols="12"
          v-for="({ title, prefix_link, list }, keyItems) in items"
          :key="keyItems"
          class="mt-4"
        >
          <Title small>
            {{ title }}
          </Title>
          <v-row class="mt-4">
            <v-col
              cols="12"
              v-for="(item, keyList) in list"
              :key="keyList"
              class="col-item"
            >
              <div class="item">
                <router-link
                  :to="
                    prefix_link
                      ? `${prefix_link}/${formatToURL(item.title)}-${item.id}`
                      : item.link
                  "
                  class="text-body-2 text-decoration-none item-title"
                >
                  {{ item.title }}
                </router-link>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-alert v-else class="mt-10" type="info">
        Nenhum item encontrado.
      </v-alert>
    </v-container>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../templates/Page.vue";
import Title from "../widgets/Title.vue";
import { formatToURL } from "../../utils/formatToURL";

export default {
  data: () => ({
    loading: true,
    items: [],
    totalItems: 0,
  }),
  computed: {
    q() {
      return this.$route.query.q;
    },
  },
  created() {
    this.get();
  },
  watch: {
    q() {
      this.get();
    },
    $route() {
      this.get();
    },
  },
  methods: {
    get() {
      this.loading = true;

      this.$rest("search")
        .get({
          params: { search: this.q },
          save: (state, data) => (this.items = data),
        })
        .then(() => (this.loading = false));
    },
    formatToURL,
  },
  components: {
    PageTemplate,
    Title,
  },
};
</script>

<style lang="scss" scoped>
.col-item {
  &:nth-child(odd) {
    background-color: #eeeeee;
  }
  .item {
    .item-title {
      color: var(--v-secondary-base);
      transition: all 0.1s linear;
      &:hover {
        color: #000000;
      }
    }
  }
}
</style>
